import { styled } from '@mui/material';
import Stack from '@mui/material/Stack';

import { Text } from '@knowz/knowz-ui';

export const StyledStack = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing(2),
  justifyContent: 'center',
  alignItems: 'center',
}));

export const StyledCenteredText = styled(Text)(({ theme }) => ({
  textAlign: 'center',
  color: theme.palette.text.secondary,
  marginBlockStart: theme.spacing(1),
}));
